import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'uikit/icons';
import { Typo } from 'uikit/content';

import { registerField } from 'core/forms';

import styles from '../styles/formFieldPlaceholder.module.scss';

const FormFieldPlaceholder = ({ schema }) => {
  const { body, title } = schema;

  return (
    <div className={styles.element}>
      <div className={styles.iconWrap}>
        <Icon icon="publishOutline" />
      </div>
      <div className={styles.textWrap}>
        <Typo variant="b02">{title}</Typo>
        <Typo variant="b01">{body}</Typo>
      </div>
    </div>
  );
};

FormFieldPlaceholder.propTypes = {
  schema: PropTypes.shape({
    body: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
};

registerField('Placeholder', React.memo(FormFieldPlaceholder));

export default FormFieldPlaceholder;
